/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUploadedFilePayloadDto
 */
export interface CreateUploadedFilePayloadDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUploadedFilePayloadDto
     */
    filePath: string;
    /**
     * 
     * @type {number}
     * @memberof CreateUploadedFilePayloadDto
     */
    fileSize: number;
    /**
     * 
     * @type {string}
     * @memberof CreateUploadedFilePayloadDto
     */
    entityType: CreateUploadedFilePayloadDtoEntityTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUploadedFilePayloadDto
     */
    entityId?: string;
}


/**
 * @export
 */
export const CreateUploadedFilePayloadDtoEntityTypeEnum = {
    Broker: 'broker',
    Claim: 'claim',
    Submission: 'submission',
    SubmissionSov: 'submission_sov',
    Binder: 'binder',
    Reinsured: 'reinsured',
    Insured: 'insured',
    Contract: 'contract',
    ContractAdjustment: 'contract_adjustment',
    ReviewNote: 'review_note',
    Receipt: 'receipt',
    Layer: 'layer'
} as const;
export type CreateUploadedFilePayloadDtoEntityTypeEnum = typeof CreateUploadedFilePayloadDtoEntityTypeEnum[keyof typeof CreateUploadedFilePayloadDtoEntityTypeEnum];


/**
 * Check if a given object implements the CreateUploadedFilePayloadDto interface.
 */
export function instanceOfCreateUploadedFilePayloadDto(value: object): value is CreateUploadedFilePayloadDto {
    if (!('filePath' in value) || value['filePath'] === undefined) return false;
    if (!('fileSize' in value) || value['fileSize'] === undefined) return false;
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    return true;
}

export function CreateUploadedFilePayloadDtoFromJSON(json: any): CreateUploadedFilePayloadDto {
    return CreateUploadedFilePayloadDtoFromJSONTyped(json, false);
}

export function CreateUploadedFilePayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUploadedFilePayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'filePath': json['filePath'],
        'fileSize': json['fileSize'],
        'entityType': json['entityType'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
    };
}

export function CreateUploadedFilePayloadDtoToJSON(json: any): CreateUploadedFilePayloadDto {
    return CreateUploadedFilePayloadDtoToJSONTyped(json, false);
}

export function CreateUploadedFilePayloadDtoToJSONTyped(value?: CreateUploadedFilePayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'filePath': value['filePath'],
        'fileSize': value['fileSize'],
        'entityType': value['entityType'],
        'entityId': value['entityId'],
    };
}

